import { apiDomain } from "./constraint";

export const sendFeedback = async (name, email, message) => {
  try {
    const response = await fetch(`${apiDomain}/clientFeedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
        email: email,
        message: message,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
